import { render, staticRenderFns } from "./pubPagination.vue?vue&type=template&id=6be16436&scoped=true&"
import script from "./pubPagination.vue?vue&type=script&lang=js&"
export * from "./pubPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be16436",
  null
  
)

export default component.exports